<button type="button" class="btn btn-link" (click)="view()">
  <i class="far fa-file-alt"></i>
</button>
